import { call, put, takeLatest } from "redux-saga/effects";
import { getProductList } from "../../../api/homeApi";
import {
  failedToFetchRecentlyViewedAction,
  requestToFetchRecentlyViewedAction,
  responseFromFetchRecentlyViewedAction,
} from "../../slices/commonSlice";
import { fetchCTDisabledEventList, getSavedAddresses, initiateFusApiCall } from "../../../api/common";
import { initiateFus, setFusData } from "../../slices/common/fus";
import { responseGetCartItemsCount } from "../../slices/cartSlice";

import {
  failedToGetCurrency,
  requestToGetCurrency,
  requestToSaveCurrency,
  requestToSaveSelectedCurrency,
} from "../../slices/common/currencyLists";
import { getCurrencyList } from "../../../api/common";
import CookieUtil from "../../../utils/storage/cookieUtil";
import { CURRENCY_ID, LOCAL_CURRENCY } from "../../../constants/common/common";
import { requestToSavedAddress, savedAddressError, setSavedAddress } from "../../slices/savedAddresses";
import { failedToGetList, requestToGetList, requestToSaveList } from "../../slices/common/cleverTapEventDisabledList";
import { endpointConst } from "../../../utils/cache-layer/cacheLayerConstants";
import { execDataLayer } from "../../../utils/cache-layer/cacheLayer";
import isEmpty from "lodash.isempty";
/**
 *
 * @param {*} action
 */
function* fetchProductListSaga() {
  try {
    const response = yield getProductList();
    if (response?.data) {
      if (response?.data?.productResults?.length > 0) {
        yield put(responseFromFetchRecentlyViewedAction(response?.data?.productResults));
      } else {
        yield put(responseFromFetchRecentlyViewedAction([]));
      }
    } else {
      yield put(failedToFetchRecentlyViewedAction({ message: "Earliest delivery dates not found", code: 404 }));
    }
  } catch (error) {
    yield put(failedToFetchRecentlyViewedAction(error));
  }
}
/**
 * Generator function to call fus api call which gets the login details, cart quantity and pincode details of customer .
 *
 */
export function* initiateFusCall() {
  try {
    const response = yield call(initiateFusApiCall);
    if (response?.checklogin?.loggedin) {
      window.userDetails = response;
    }
    yield put(setFusData(response));
    yield put(responseGetCartItemsCount(response?.cart?.cartTotalQuantity));
  } catch (error) {
    // yield put({ type: SET_ERROR, payload: error });
  }
}

/** */
function* fetchCurrencyListSaga() {
  try {
    const response = yield getCurrencyList();
    if (response?.currencies) {
      yield put(requestToSaveCurrency(response.currencies));
      const localCurrencyId = CookieUtil.getCookie(LOCAL_CURRENCY);
      if (localCurrencyId) {
        const userSelectedCurrency = response?.currencies?.find((item) => item.currency.id === localCurrencyId);
        yield put(requestToSaveSelectedCurrency(userSelectedCurrency));
      } else {
        CookieUtil.setCookie(LOCAL_CURRENCY, CURRENCY_ID, { path: "/", encode: decodeURIComponent });
        const userSelectedCurrency = response?.currencies?.find((item) => item.currency.id === CURRENCY_ID);
        yield put(requestToSaveSelectedCurrency(userSelectedCurrency));
      }
    }
  } catch (error) {
    yield put(failedToGetCurrency(error));
  }
}

/** */
function* fetchSavedAddresses() {
  try {
    const response = yield getSavedAddresses();
    yield put(setSavedAddress(response?.data?.addressList));
  } catch (error) {
    yield put(savedAddressError(error));
  }
}

/** */
function* fetchCtDisableEvents() {
  try {
    /** */
    const apiFn = () => fetchCTDisabledEventList();
    const res = yield call(execDataLayer, apiFn, endpointConst.ctDisabledEvents);
    const resData =
      (typeof res === "string" && !isEmpty(res.trim()) && !res?.errorCode) ||
      (typeof res === "object" && res !== null && !res?.errorCode)
        ? res
        : [];
    yield put(requestToSaveList(resData));
  } catch (error) {
    yield put(failedToGetList(error));
  }
}

/**
 * Description placeholder
 *
 * @export
 * @returns {{}}
 */
export function* watcherFetchCommonSaga() {
  yield takeLatest(requestToFetchRecentlyViewedAction.type, fetchProductListSaga);
  yield takeLatest(initiateFus.type, initiateFusCall);
  yield takeLatest(requestToGetCurrency.type, fetchCurrencyListSaga);
  yield takeLatest(requestToSavedAddress.type, fetchSavedAddresses);
  yield takeLatest(requestToGetList.type, fetchCtDisableEvents);
}
